export function isImageSrc(src: string) {
  return src.startsWith('http') || src.startsWith('data:image/svg+xml')
}

export function hexToRgb(hex: string): [r: number, g: number, b: number] {
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i
  hex = hex.replace(shorthandRegex, (_m, r, g, b) => {
    return r + r + g + g + b + b
  })

  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  return result
    ? [
        Number.parseInt(result[1], 16),
        Number.parseInt(result[2], 16),
        Number.parseInt(result[3], 16),
      ]
    : [0, 0, 0]
}

export function isLight(hexColor: string) {
  return (([r, g, b]) => (r * 299 + g * 587 + b * 114) / 1000 > 155)(
    hexToRgb(hexColor),
  )
}

export function readFileData(url: string, callback: (error: Error | null, data: string | null) => any): any {
  return fetch(url)
    .then(response => response.text())
    .then(data => callback(null, data))
    .catch(error => callback(error, null))
}

export function svgToUri(svg: string) {
  return `data:image/svg+xml;utf8,${svg.replace('<svg', (~svg.indexOf('xmlns') ? '<svg' : '<svg xmlns="http://www.w3.org/2000/svg"'))
    .replace(/"/g, '\'')
    .replace(/%/g, '%25')
    .replace(/#/g, '%23')
    .replace(/{/g, '%7B')
    .replace(/}/g, '%7D')
    .replace(/</g, '%3C')
    .replace(/>/g, '%3E')}`
}

export async function getSvgCSS(svg: any) {
  return await readFileData(svg, (err, data) => {
    if (err)
      throw err
    const mode = data!.includes('currentColor')
      ? 'mask'
      : 'background-img'

    const uri = `url("${svgToUri(data!)}")`

    // monochrome
    if (mode === 'mask') {
      return `
        mask: ${uri} no-repeat;
        mask-size: 100% 100%;
        background-color: currentColor;
        height: 1em;
        width: 1em;
      `
    }
    // colored
    else {
      return `
        background: ${uri} no-repeat;
        background-size: 100% 100%;
        background-color: transparent;
        height: 1em;
        width: 1em;
      `
    }
  })
}
